export default "__VITE_ASSET__CEP_rJM2__"